export const Play = () => (
  <svg focusable={false} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      d='M9.707 18.705c-.63.63-1.707.184-1.707-.707V6.002c0-.89 1.077-1.337 1.707-.707l6 5.998a1 1 0 0 1 0 1.414l-6 5.998z'
    />
  </svg>
);
